import * as React from "react";
import type { SVGProps } from "react";
const SvgHouseHeating = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m20.6 8.2-8-6a.99.99 0 0 0-1.2 0l-8 6c-.25.19-.4.49-.4.8v12c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V9c0-.31-.15-.61-.4-.8M19 20H5V9.5l7-5.25 7 5.25z"
    />
    <path
      fill="currentColor"
      d="M8.83 10.45a1.01 1.01 0 0 0-1.39-.28c-.46.3-.58.93-.28 1.39.68 1.02.42 1.54-.06 2.5-.53 1.06-1.26 2.52.06 4.5.19.29.51.45.83.45.19 0 .38-.05.55-.17.46-.31.58-.93.28-1.39-.68-1.02-.42-1.54.06-2.5.53-1.06 1.26-2.52-.06-4.5zM11.5 9.14c-.48.28-.64.89-.36 1.37.74 1.28.43 2-.05 3.1-.54 1.23-1.2 2.75.05 4.9.19.32.52.5.87.5.17 0 .34-.04.5-.14.48-.28.64-.89.36-1.37-.74-1.28-.43-2 .05-3.1.54-1.23 1.2-2.75-.05-4.9a1 1 0 0 0-1.37-.36M15.17 18.56c.19.29.51.45.83.45.19 0 .38-.05.55-.17.46-.31.58-.93.28-1.39-.68-1.02-.42-1.54.06-2.5.53-1.06 1.26-2.52-.06-4.5a1.01 1.01 0 0 0-1.39-.28c-.46.3-.58.93-.28 1.39.68 1.02.42 1.54-.06 2.5-.53 1.06-1.26 2.52.06 4.5z"
    />
  </svg>
);
export default SvgHouseHeating;
